module.exports = __webpack_public_path__ + "img/windows.dcaa85ec.png";